
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ru/[treatment]",
      function () {
        return require("private-next-pages/ru/[treatment].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ru/[treatment]"])
      });
    }
  